<i18n src="@/locales/modules/AlarmTranslate.json"></i18n>
<template>
	<div class="data-list-container">
		<vs-table ref="table" class="stack-table" :sst="true" :data="alarms" :max-items="limit" :noDataText="$t('Notify.NoDataAvailable')" @sort="mixinHandleSort">
			<div slot="header" class="flex flex-grow justify-end">
				<vs-input @input="mixinHandleSearch" size="large" class="input-search mr-3 md:block lg:block xl:block hidden" icon="search" :placeholder="$t('Actions.Search')" v-model="searchText" />
				<div class="md:flex lg:flex xl:flex hidden">
					<vs-button v-if="mixinIsCanCreateAlarm" class="w-30 font-bold" type="filled" @click="addNewData">{{ $t("Actions.Create") }}</vs-button>
				</div>
			</div>

			<template slot="thead">
				<vs-th class="no-sorter"></vs-th>

				<vs-th sort-key="name" class="custom-sort-filter">{{ $t("Name") }}</vs-th>
				<vs-th sort-key="code">{{ $t("Object") }}</vs-th>
				<vs-th sort-key="limit">{{ $t("CreateAt") }}</vs-th>
				<vs-th class="no-sorter"></vs-th>
			</template>

			<template slot-scope="{ data }">
				<tbody>
					<vs-tr class="cursor-pointer" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							<span v-if="tr.enable" class="inline-block rounded-full h-3 w-3 bg-success"></span>
							<span v-if="!tr.enable" class="inline-block rounded-full h-3 w-3 bg-gray-4"></span>
						</vs-td>
						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('Name')">
							<p class="text-base">{{ tr.name }}</p>
						</vs-td>

						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('Object')">
							<p class="text-base">{{ tr.object }}</p>
						</vs-td>

						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('CreateAt')">
							<p class="text-base">{{ tr.created_at | dateTime(userDateTimeFormat) }}</p>
						</vs-td>

						<vs-td class="whitespace-no-wrap text-right">
							<BasicContextMenu type="vertical" :target="tr" @onClickEdit="handleEdit" @onClickDelete="showDeleteConfirm" />
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<CbsPagination class="mt-3" :total="totalPages" v-model="page" />
		<AlarmSettingForm
			:data="alarmDialogData"
			:isSidebarActive="isAlarmFormDialogActive"
			@closeSidebar="toggleAlarmFormSidebar"
			@onClickAddQuote="handleAddQuote"
			@onClickEdit="handleEdit"
			@onClickDelete="showDeleteConfirm"
		/>
	</div>
</template>

<script>
import moduleAlarm from "@/store/alarm/moduleAlarm";
import { withBasicQueries, alarmPermissions, getUserPermissions } from "@/mixins/mixins.js";
import AlarmSettingForm from "./AlarmSettingForm.vue";
import BasicContextMenu from "@/components/basic-context-menu/BasicContextMenu";

export default {
	name: "AlarmSettingList",
	components: {
		AlarmSettingForm,
		BasicContextMenu
	},
	mixins: [
		withBasicQueries,
		getUserPermissions({
			...alarmPermissions
		})
	],
	computed: {
		alarms() {
			return this.$store.state.alarmManagement.alarmsSetting.filter(item => item.form_data);
		},
		totalPages() {
			return Math.ceil(this.$store.state.alarmManagement.totalAlarmsSetting / this.limit);
		}
	},
	data() {
		return {
			page: 1,
			limit: 10,
			searchText: "",
			alarmDialogData: {},
			isAlarmFormDialogActive: false
		};
	},
	watch: {
		page() {
			this.getAlarmsSetting();
		},
		"$route.query"() {
			this.getAlarmsSetting();
		}
	},
	methods: {
		async getAlarmsSetting() {
			this.$vs.loading();
			await this.$store.dispatch("alarmManagement/fetchAlarmsSetting", {
				page: this.page,
				search: this.searchText.trim(),
				limit: this.limit
			});
			this.$vs.loading.close();
		},
		addNewData() {
			this.alarmDialogData = {};
			this.toggleAlarmFormSidebar(true);
		},
		handleClickItemRow(event, alarm) {
			this.alarmDialogData = alarm;
			this.toggleAlarmFormSidebar(true);
		},
		toggleAlarmFormSidebar(val) {
			this.isAlarmFormDialogActive = val ? val : false;
		},

		handleAddQuote() {},
		handleEdit(product) {
			this.productDialogData = product;
			this.toggleAlarmFormSidebar(true);
		},
		async handleDelete(prod) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("alarmManagement/deleteAlarm", {
					id: prod.id
				});
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("DeleteAlarmSuccessful")
					}
				});
				if (this.isAlarmFormDialogActive) {
					this.toggleAlarmDetailSidebar(false);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		showDeleteConfirm(prod) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.handleDelete(prod),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		}
	},
	created() {
		this.$store.registerModule("alarmManagement", moduleAlarm);
		this.getAlarmsSetting();
	},
	beforeDestroy() {
		this.$store.unregisterModule("alarmManagement");
	}
};
</script>

<style></style>
